import React from "react";
import styled from "styled-components";
import ProgressBar from "react-bootstrap/ProgressBar";
import { RowContainer } from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { greyText, graphPaletteV2 } from "../../../styles";
import { EngagementItem } from "../../../models/stewardshipModels";
import { calculateTotalEngagementsByMilestone } from "../utils";
import { ENGAGEMENT_TYPES, MILESTONE_TYPES } from "../constants";

const BarsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 275px;
  padding: 30px;
  overflow-y: auto;
  align-items: center;
`;

const MilestoneProgressBar = styled(ProgressBar)`
  height: 8px;
  width: 85%;
  background-color: transparent;
`;

const ManagerParagrapContainer = styled.div`
  width: 120px;
  overflow-x: auto;
`;

export const MilestoneProgressBars = ({
  data,
}: MilestoneProgressBarsProps): JSX.Element => {
  return (
    <BarsContainer>
      {ENGAGEMENT_TYPES.map((item) => {
        const totalForCategory = calculateTotalEngagementsByMilestone(
          data,
          null,
          item.key
        );

        return (
          <RowContainer
            key={`${item.key}-container`}
            mb={20}
            jc="flex-start"
            ai="center"
          >
            <ManagerParagrapContainer>
              <CompassParagraph color={greyText} fontSize={12} mr={15}>
                {item.displayValue}
              </CompassParagraph>
            </ManagerParagrapContainer>
            <MilestoneProgressBar>
              {MILESTONE_TYPES.map((milestone, index) => {
                const engagementsForMilestone =
                  calculateTotalEngagementsByMilestone(
                    data,
                    milestone.key,
                    item.key
                  );
                const percentage =
                  (engagementsForMilestone / totalForCategory) * 100;
                return (
                  <ProgressBar
                    key={`${milestone.key}-${item.key}`}
                    now={percentage}
                    style={{
                      backgroundColor: graphPaletteV2[index],
                    }}
                  />
                );
              })}
            </MilestoneProgressBar>
          </RowContainer>
        );
      })}
    </BarsContainer>
  );
};

type MilestoneProgressBarsProps = {
  data: EngagementItem[];
};
